import React, { useEffect, useState } from "react";

import Checkbox from "../../../atoms/input/checkbox";
import TableText from "../../../atoms/text/table/tableText";
import PretendardText from "../../../atoms/text/pretendardText";
import MainInput from "../../../atoms/input/mainInput";

import Popup from "../../../molecules/popup";

import SelectBox from "../../../organisms/selectBox";

import PopupOverLay from "../../PopupOverlay";
import GroupApi from "../../../../api/group.api";
import { errorHandler } from "../../../../util/errorHandler";
import { toast } from "react-toastify";
import { toastMsg } from "../../../../util/toastMsg";
import Modal from "../../Modal";
import { route } from "../../../../router/route";
import menuListConst from "../../../../constants/menuList";

const AdminGroupManagePopup = ({
  setPopupOpen,
  selectedGroupValue,
  getOperateGroupList,
}) => {
  // 그룹 유형 선택 관련
  const [titleValue, setTitleValue] = useState("");
  const [selectedGroupType, setSelectedGroupType] = useState("운영진 그룹");
  const [groupTypeListBoxOpen, setGroupTypeListBoxOpen] = useState(false);
  // 카테고리 삭제하기
  const [mainCategoryDeleteModalOpen, setMainCategoryDeleteModalOpen] =
    useState(false);

  useEffect(() => {
    if (selectedGroupValue.id !== 0) {
      setSelectedGroupType("운영진 그룹");

      setTitleValue(selectedGroupValue.title);
      setReadPermissions(selectedGroupValue.readAuthorityList);
      setWritePermissions(selectedGroupValue.updateAuthorityList);
    }
  }, [selectedGroupValue]);

  const groupTypeList = [
    {
      title: "운영진 그룹",
      id: "운영진 그룹",
    },
  ];

  const [readPermissions, setReadPermissions] = useState([]);
  const [writePermissions, setWritePermissions] = useState([]);
  const [isOpenList, setIsOpenList] = useState([]);

  const menuList = menuListConst;

  // 그룹 등록
  const createGroupFunc = async () => {
    try {
      if (titleValue === "") {
        return toast("그룹명을 입력해주세요.");
      }

      const data = {
        title: titleValue,
        memberGroupType: "OPERATE",
        readAuthorityList: readPermissions,
        updateAuthorityList: writePermissions,
      };

      await GroupApi.create(data);
      setPopupOpen(false);
      toast(toastMsg.create);
      getOperateGroupList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 그룹 수정
  const editGroupFunc = async () => {
    try {
      if (titleValue === "") {
        return toast("그룹명을 입력해주세요.");
      }

      const data = {
        title: titleValue,
        readAuthorityList: readPermissions,
        updateAuthorityList: writePermissions,
      };

      await GroupApi.edit(selectedGroupValue.id, data);
      setPopupOpen(false);
      toast(toastMsg.create);
      getOperateGroupList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 그룹 삭제
  const deleteGroupFunc = async () => {
    try {
      await GroupApi.delete(selectedGroupValue.id);
      setPopupOpen(false);
      toast(toastMsg.delete);
      getOperateGroupList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const handlePermissionChange = (
    permissions,
    setPermissions,
    value,
    subMenu
  ) => {
    setPermissions((prev) => {
      const isIncluded = prev.includes(value);
      if (isIncluded) {
        // Remove the value and all subMenu values
        return prev.filter(
          (val) => val !== value && !subMenu.some((sub) => sub.value === val)
        );
      } else {
        // Add the value and all subMenu values
        const subMenuValues = subMenu.map((sub) => sub.value);
        return [...prev, value, ...subMenuValues];
      }
    });
  };

  return (
    <>
      <PopupOverLay
        isOpen={true}
        onClick={() => {
          setPopupOpen(false);
        }}
      >
        <Popup
          headerTitle={
            selectedGroupValue.id !== 0 ? "그룹 정보 수정" : "새 그룹 만들기"
          }
          footerBtnText="저장하기"
          onClick={() => {
            setPopupOpen(false);
          }}
          footerBtnHandler={() => {
            if (selectedGroupValue.id !== 0) {
              editGroupFunc();
            } else {
              createGroupFunc();
            }
          }}
        >
          <div
            className="custom-scrollbar"
            style={{
              width: "100%",
              height: 350,
              overflowY: "auto",
              padding: "0px 30px",
              margin: "24px 0px 20px 0px",
              display: "flex",
              flexDirection: "column",
              gap: 30,
            }}
          >
            {/* 그룹명 */}
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <PretendardText
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  color: "#aaa",
                  marginBottom: 16,
                }}
              >
                그룹명
              </PretendardText>
              <MainInput
                type={"text"}
                placeholder={"그룹명을 입력해 주세요."}
                style={{ width: "338px" }}
                value={titleValue}
                onChange={(e) => setTitleValue(e.target.value)}
              />
            </div>
            {/* 그룹 유형 선택 */}
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <PretendardText
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  color: "#aaa",
                  marginBottom: 16,
                }}
              >
                그룹 유형 선택
              </PretendardText>
              <SelectBox
                selectedValue={selectedGroupType}
                isOpen={groupTypeListBoxOpen}
                wrapperHandler={() => {
                  setGroupTypeListBoxOpen(!groupTypeListBoxOpen);
                }}
                itemList={groupTypeList}
                selectedValueSetterFunc={(value) => {
                  setSelectedGroupType(value.id);
                  setGroupTypeListBoxOpen(false);
                }}
                disabled={selectedGroupValue.id !== 0 ? true : false}
              />
            </div>

            {selectedGroupType === "운영진 그룹" && (
              <PretendardText
                style={{
                  fontSize: "13px",
                  fontWeight: "500",
                  lineHeight: "18.75px",
                  color: "#cf6679",
                }}
              >
                · 운영진 그룹으로 설정된 사용자는 (관리자 페이지) 주소를
                브라우저에 직접 입력하여 관리자 페이지에 접근할 수 있습니다.
              </PretendardText>
            )}

            {/* 메뉴별 권한 설정 */}
            {selectedGroupType === "운영진 그룹" && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    lineHeight: "22px",
                    color: "#aaa",
                    marginBottom: 16,
                  }}
                >
                  메뉴별 권한설정
                </PretendardText>
                <table
                  style={{
                    width: "100%",
                    borderSpacing: 0,
                    borderCollapse: "collapse",
                  }}
                >
                  <colgroup>
                    {/* 합계: 572px */}
                    {/* 항목 */}
                    <col width="362px" />
                    {/* 조회권한 */}
                    <col width="110px" />
                    {/* 편집권한 */}
                    <col width="100px" />
                  </colgroup>
                  <thead>
                    <tr
                      style={{
                        height: 41,
                        backgroundColor: "#313233",
                        borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                      }}
                    >
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            paddingLeft: 24,
                          }}
                        >
                          항목
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                          }}
                        >
                          조회권한
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                          }}
                        >
                          편집권한
                        </TableText>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {menuList.map((menu, index) => (
                      <React.Fragment key={index}>
                        {/* Main Menu */}
                        <tr
                          style={{
                            height: 49,
                            borderBottom:
                              "0.5px solid rgba(255, 255, 255, 0.12)",
                          }}
                        >
                          <td>
                            <div
                              style={{
                                width: 297,
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                paddingLeft: 12,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setIsOpenList((prev) =>
                                  prev.includes(menu.value)
                                    ? prev.filter((val) => val !== menu.value)
                                    : [...prev, menu.value]
                                );
                              }}
                            >
                              <img
                                className={
                                  isOpenList.includes(menu.value)
                                    ? "rotate"
                                    : "rotate-back"
                                }
                                style={{
                                  width: "18px",
                                  height: "18px",
                                }}
                                src="/assets/admin/icons/ico_select_arrow_down.svg"
                                alt="펼치기"
                              />
                              <TableText>{menu.title}</TableText>
                            </div>
                          </td>
                          <td>
                            <Checkbox
                              checked={readPermissions.includes(menu.value)}
                              onChange={() =>
                                handlePermissionChange(
                                  readPermissions,
                                  setReadPermissions,
                                  menu.value,
                                  menu.subMenu
                                )
                              }
                            />
                          </td>
                          <td>
                            {menu.value !== route.statistics &&
                              menu.value !== route.home && (
                                <Checkbox
                                  checked={writePermissions.includes(
                                    menu.value
                                  )}
                                  onChange={() =>
                                    handlePermissionChange(
                                      writePermissions,
                                      setWritePermissions,
                                      menu.value,
                                      menu.subMenu
                                    )
                                  }
                                />
                              )}
                          </td>
                        </tr>

                        {/* SubMenu */}
                        {isOpenList.includes(menu.value) &&
                          menu.subMenu.map((sub, subIndex) => (
                            <tr
                              key={subIndex}
                              style={{
                                height: 49,
                                borderBottom:
                                  "0.5px solid rgba(255, 255, 255, 0.12)",
                              }}
                            >
                              <td>
                                <TableText style={{ paddingLeft: 38 }}>
                                  {sub.title}
                                </TableText>
                              </td>
                              <td>
                                <Checkbox
                                  checked={readPermissions.includes(sub.value)}
                                  onChange={() =>
                                    setReadPermissions((prev) =>
                                      prev.includes(sub.value)
                                        ? prev.filter(
                                            (val) => val !== sub.value
                                          )
                                        : [...prev, sub.value]
                                    )
                                  }
                                />
                              </td>
                              <td>
                                {menu.value !== route.statistics &&
                                  menu.value !== route.home && (
                                    <Checkbox
                                      checked={writePermissions.includes(
                                        sub.value
                                      )}
                                      onChange={() =>
                                        setWritePermissions((prev) =>
                                          prev.includes(sub.value)
                                            ? prev.filter(
                                                (val) => val !== sub.value
                                              )
                                            : [...prev, sub.value]
                                        )
                                      }
                                    />
                                  )}
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {selectedGroupValue?.id !== 0 && (
              <div
                style={{
                  marginTop: 80,
                  width: "100%",
                  height: 22,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    lineHeight: "21.5px",
                    color: "var(--text3, rgba(181, 181, 181, 0.5))",
                    marginTop: "5px",
                    cursor: "pointer",
                    textDecorationLine: "underline",
                  }}
                  onClick={() => {
                    setMainCategoryDeleteModalOpen(true);
                  }}
                >
                  삭제하기
                </PretendardText>
              </div>
            )}
          </div>
        </Popup>
      </PopupOverLay>

      {/* 메인 카테고리 삭제하기 모달 */}
      {mainCategoryDeleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setMainCategoryDeleteModalOpen}
          onClick={() => {
            deleteGroupFunc();
          }}
        />
      )}
    </>
  );
};

export default AdminGroupManagePopup;
